if (!customElements.get('product-form')) {
  customElements.define(
      'product-form', 
    class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');

      const addonItems = this.getSelectedAddonItems();
      if (addonItems.length) {
        this.submitWithAddonItems(addonItems);
        return;
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      
      const formAttr= this.getAttribute('data-template');

      if (formAttr == 'cart') {
        config.body = formData;
  
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            return;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            location.reload();
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          });

      } else {
        if (this.dataset.cartType != 'page') {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
  
        config.body = formData;
  
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {

            if (response.status) {

              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);
  
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (this.dataset.cartType == 'page') {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
  
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cart.renderContents(response) });
              }, { once: true });
              quickAddModal.hide(true);
              this.cart.renderContents(response);
            } else {
              this.cart.renderContents(response);
            }
						const productModal = this.closest('.modal-product-detail');
						const elemenOption = document.querySelector('.product-quickview .variant-selects');
						let mainGallery = document.querySelector('#Slider-Gallery-quickview .swiper-wrapper');
						let thumbsGallery = document.querySelector('#Slider-Thumbnails-quickview .swiper-wrapper');

						if (productModal) {
							productModal.style.display = 'none';
							document.querySelector('body').classList.remove('overflow-hidden');
							elemenOption.innerHTML = '';
							mainGallery.innerHTML = '';
							thumbsGallery.innerHTML = '';
							document.querySelector('.modal-product-detail .product__description').innerHTML = '';
						}
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          });
      }
    }

    getSelectedAddonItems() {
      const productInfo = this.closest('.product__info-container');
      if (!productInfo) return [];
      const addons = productInfo.querySelector('product-addons');
      if (!addons || typeof addons.getSelectedItems !== 'function') return [];
      return addons.getSelectedItems();
    }

    submitWithAddonItems(addonItems) {
      const variantInput = this.form.querySelector('[name="id"]');
      const quantityInput = this.form.querySelector('[name="quantity"]');
      const mainId = Number(variantInput && variantInput.value);
      const mainQty = Number((quantityInput && quantityInput.value) || 1);

      if (!mainId) {
        this.handleErrorMessage('Product variant is unavailable.');
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        return;
      }

      const body = {
        items: [{ id: mainId, quantity: mainQty }].concat(addonItems),
      };

      if (this.dataset.cartType != 'page' && this.cart) {
        body.sections = this.cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
        this.cart.setActiveElement(document.activeElement);
      }

      fetch(`${routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: String(mainId),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description || response.message);
            this.error = true;
            return;
          }

          if (this.dataset.cartType == 'page') {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: String(mainId),
            cartData: response,
          });

          if (this.cart) this.cart.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
          this.handleErrorMessage(e.message);
          this.error = true;
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = 
        this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

      if (!this.errorMessageWrapper) return;

      
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}